import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { UnfoldMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IReferralDetail } from "../../../services/affiliate";
import { useState } from "react";

interface UserTableProps {
  referrals: IReferralDetail[];
}

const UserTable = ({ referrals }: UserTableProps) => {
  const [loading, setLoading] = useState(false);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatAmount = (amount: number) => {
    return `NGN ${amount.toLocaleString()}`;
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "booked_successfully":
      case "success":
        return {
          bg: "#ECFDF3",
          color: "#379E66",
          text: "Paid",
        };
      case "pending":
        return {
          bg: "#FEF3E7",
          color: "#F9A000",
          text: "Pending",
        };
      default:
        return {
          bg: "#FEE4E2",
          color: "#DA4733",
          text: "Failed",
        };
    }
  };

  return (
    <Box sx={{ borderRadius: "10px", marginTop: "20px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px" }}>
          Referral Logs
        </Typography>
        {/* <Box sx={{ display: "flex", gap: 1, fontSize: "14px" }}>
          <IconButton
            sx={{
              color: "#667185",
              fontSize: "14px",
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <SearchIcon sx={{ fontSize: "16px" }} /> <span>Search</span>
          </IconButton>
          <IconButton
            sx={{
              color: "#667185",
              fontSize: "14px",
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <FilterListIcon sx={{ fontSize: "16px" }} /> <span>Filter</span>
          </IconButton>
          <IconButton
            sx={{
              color: "#667185",
              fontSize: "14px",
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <UnfoldMore sx={{ fontSize: "16px" }} /> <span>Sort</span>
          </IconButton>
        </Box> */}
      </Box>

      {/* Table */}
      <Box>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
            <Table>
              <TableHead sx={{ bgcolor: "#F9FAFB" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      color: "#344054",
                      fontWeight: "400",
                      fontSize: "14px",
                      padding: "14px",
                    }}
                  >
                    Referred User
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#344054",
                      fontWeight: "400",
                      fontSize: "14px",
                      padding: "14px",
                    }}
                  >
                    Date Registered
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#344054",
                      fontWeight: "400",
                      fontSize: "14px",
                      padding: "14px",
                    }}
                  >
                    Booking Status
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#344054",
                      fontWeight: "400",
                      fontSize: "14px",
                      padding: "14px",
                    }}
                  >
                    Coin Earned
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      color: "#344054",
                      fontWeight: "400",
                      fontSize: "14px",
                      padding: "14px",
                    }}
                  >
                    Actions
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {referrals.length > 0 ? (
                  referrals.map((referral, index) => {
                    const statusStyle = getStatusColor(referral.bookingStatus);
                    return (
                      <TableRow key={index}>
                        <TableCell sx={{ color: "#344054" }}>
                          {referral.customer_name}
                        </TableCell>
                        <TableCell sx={{ color: "#667185" }}>
                          {formatDate(referral.transactionDate)}
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              backgroundColor: statusStyle.bg,
                              color: statusStyle.color,
                              px: 1.5,
                              py: 0.5,
                              borderRadius: "12px",
                              display: "inline-block",
                              fontSize: "14px",
                              fontWeight: 400,
                            }}
                          >
                            {statusStyle.text}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ color: "#667185" }}>
                          {formatAmount(referral.amountEarned)}
                        </TableCell>
                        {/* <TableCell>
                          <IconButton>
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                      No referral data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
};

export default UserTable;
